import React, { Component } from 'react';
import Toolbar from '@material-ui/core/Toolbar'; 
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import './App.css';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }));

function Eindetoernooi() {
        const classes = useStyles()
        return (
             <div align="center">
      <Toolbar>
        <Paper style={{padding: 25, marginTop: 50, backgroundColor: "steelblue", color: "white", alignSelf: "center"}}>
      <Typography variant="h6" className={classes.title} >
             NK 5Pins en Biatlon 2019 zijn voorbij. 
           </Typography>
           <Typography variant="h6" className={classes.title}>
           De definitieve resultaten zijn beschikbaar. Klik op de links in het menu voor de overzichten.
           </Typography>
           <Typography variant="h6" className={classes.title}>
           De definitieve ranglijst over 4 seizoenen komt binnenkort beschikbaar.
           </Typography>
           <Typography variant="subtitle2" style={{align: "flex-end", marginTop: 20}}>Beverwijk, 29 oktober Pierre de Boer</Typography>
           </Paper>
      </Toolbar>
  </div>
        );
    }


export default Eindetoernooi;